import { Grid, Typography, Button, Icon } from '@material-ui/core';
import React, { Fragment, useState } from 'react';
import { toast } from 'react-toastify';
import { useObservable, useCallbackObservable } from 'react-use-observable';
import { of } from 'rxjs';
import { tap, catchError } from 'rxjs/operators';
import eduzzAccountsService from 'v2/services/eduzzAccount';

const Password = () => {
  const [sent, setSent] = useState<boolean>(false);
  const [user] = useObservable(() => eduzzAccountsService.getUser(), []);
  const [onSend] = useCallbackObservable(() => {
    setSent(false);
    return eduzzAccountsService.changePassword().pipe(
      tap(() => {
        try {
          setSent(true);
          toast.success('O e-mail para alteração da senha foi enviado!');
        } catch (error) {
          toast.error(error);
        }
      }),
      catchError((err) => {
        setSent(false);
        toast.error(err);
        return of(true);
      })
    );
  }, []);

  return (
    <Fragment>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          {sent ? (
            <>
              <Typography>Um processo de alteração de senha foi iniciado.</Typography>
              <Typography>
                Um e-mail foi enviado para: <b>{user?.email}</b>
              </Typography>
              <i>* Confira sua caixa de spam.</i>
            </>
          ) : (
            <Typography>
              Para iniciar o processo de alteração de senha dessa conta, clique no botão abaixo e aguarde as instruções no seu e-mail:{' '}
              <b>{user?.email}</b>
            </Typography>
          )}
        </Grid>
        <Grid item xs={12} container direction='row' justify='flex-end' alignItems='center'>
          <Button variant='contained' color='primary' onClick={onSend} disabled={sent}>
            <Icon style={{ fontSize: 18, marginRight: 4 }}>lock_open</Icon> Alterar Senha
          </Button>
        </Grid>
      </Grid>
    </Fragment>
  );
};

export default Password;
